import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AddDevice from '../../images/AddDevice.svg';
import { Box, Divider, Grid, Modal, Select, TextField, Typography } from '@mui/material';
import { useMutation } from 'react-query';
import { checkDevicePin } from '../../utils/api';
import { isEmpty, map, range } from 'lodash';
import PhoneInput from 'react-phone-number-input';
import moment from 'moment';
import Button from '../../components/Button';
import IconButton from '../../components/IconButton';
import { useUserLocation } from '../../hooks/useUserLocation';

const AddDeviceModal = ({ show, onClose, userData, handlePairDevice, error, loader }) => {
  const [state, setState] = React.useState({
    pin: '',
    name: '',
    email: '',
    phoneNo: '',
    birthday: '',
    height: '',
    weight: '',
    step: 1,
    errorMessage: '',
  });

  const { country } = useUserLocation();

  React.useEffect(() => {
    if (!isEmpty(error)) {
      setState((prev) => {
        return { ...prev, errorMessage: error };
      });
    }
  }, [error]);

  const checkDevicePinHandler = useMutation(checkDevicePin, {
    onSuccess: async (data) => {
      setState((prev) => {
        return { ...prev, step: prev.step + 1, errorMessage: '' };
      });
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  React.useEffect(() => {
    if (!isEmpty(userData)) {
      const { data } = userData;
      setState((prev) => {
        return {
          ...prev,
          name: data?.fullName || '',
          birthday: !isEmpty(data?.userInfo?.birthdate) ? moment(data?.userInfo?.birthdate).format('YYYY-MM-DD') : '',
          phoneNo: data?.username || '',
          email: data?.email || '',
          height: data?.userInfo?.height || '',
          weight: data?.userInfo?.weight || '',
        };
      });
    }
  }, [userData]);

  const handleCheckDevice = async () => {
    if (isEmpty(state.pin)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Pin cannot be empty!' };
      });
    }
    checkDevicePinHandler.mutate({ pin: state.pin });
  };

  const handlePressEnter = (e) => {
    if (e.key === 'Enter') {
      handleCheckDevice();
    }
  };

  return (
    <Modal open={show} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      {state.step === 1 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '50%',
            p: 6,
            bgcolor: 'background.paper',
            borderRadius: 2.5,
            position: 'relative',
            top: 100,
            left: 350,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2.5,
              width: 740,
              mx: 'auto',
            }}
          >
            <Typography variant="body1" color="text.secondary" align="center">
              Step 1 of 2
            </Typography>
            <Typography variant="h4" align="center">
              CAN user information
            </Typography>
            <Typography variant="h5" align="center">
              Pair cane with your account
            </Typography>
            <Typography variant="body1" color="text.secondary" align="center">
              Press the flashlight button for 10 seconds on your smartcane to show the cane PIN number
            </Typography>
            <Box component="img" src={AddDevice} alt="Image" sx={{ width: 440, height: 198 }} />
            <Box sx={{ width: 440 }}>
              <Typography variant="body2" color="text.secondary">
                Enter PIN here
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={state.pin}
                onChange={(e) =>
                  setState((prev) => {
                    return { ...prev, pin: e.target.value };
                  })
                }
                InputProps={{
                  sx: { borderRadius: 50 },
                }}
                onKeyPress={handlePressEnter}
              />
            </Box>
          </Box>
          <IconButton
            style={{
              position: 'absolute',
              top: 6,
              right: 6,
            }}
            onClick={onClose}
          />
          <Typography variant="subtitle1" style={{ color: 'red' }} textAlign="center">
            {state.errorMessage}
          </Typography>
          <Divider sx={{ mt: 4 }} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              pt: 4,
            }}
          >
            <Button bg="light" text="Cancel" onClick={onClose} />
            <Button text="Next" onClick={handleCheckDevice} />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '50%',
            p: 3,
            bgcolor: 'background.paper',
            borderRadius: 2.5,
            position: 'relative',
            top: 100,
            left: 350,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2.5,
              width: '100%',
              mx: 'auto',
            }}
          >
            <Typography variant="body1" color="text.secondary" align="center">
              Step 2 of 2
            </Typography>
            <Typography variant="h4" align="center">
              CAN user information
            </Typography>
            <Typography variant="body1" color="text.secondary" align="center">
              Enter the general information about yourself to create your account
            </Typography>

            <Grid container direction={'row'}>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Full Name
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={state.name}
                    onChange={(e) =>
                      setState((prev) => {
                        return { ...prev, name: e.target.value };
                      })
                    }
                    InputProps={{
                      sx: { borderRadius: 50 },
                    }}
                  />
                </Box>
              </Grid>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Email
                  </Typography>
                  <TextField
                    disabled={true}
                    fullWidth
                    variant="outlined"
                    value={state.email}
                    onChange={(e) =>
                      setState((prev) => {
                        return { ...prev, email: e.target.value };
                      })
                    }
                    InputProps={{
                      sx: { borderRadius: 50 },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction={'row'}>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Phone number
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <PhoneInput
                      placeholder="Enter phone number"
                      defaultCountry={country}
                      addInternationalOption={true}
                      limitMaxLength={true}
                      style={{
                        border: '1px solid #C2C8D6',
                        boxSizing: 'border-box',
                        height: '57px',
                        paddingLeft: '20px',
                        borderRadius: '100px',
                        width: '100%',
                      }}
                      value={state.phoneNo}
                      numberInputProps={{
                        className: 'input-child input-child-2',
                      }}
                      onChange={(value) =>
                        setState((prev) => {
                          return {
                            ...prev,
                            phoneNo: value,
                          };
                        })
                      }
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Birthday
                  </Typography>
                  <TextField
                    type="date"
                    fullWidth
                    variant="outlined"
                    value={state.birthday}
                    onChange={(e) =>
                      setState((prev) => {
                        return { ...prev, birthday: e.target.value };
                      })
                    }
                    InputProps={{
                      sx: { borderRadius: 50 },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction={'row'}>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Weight
                  </Typography>
                  <Select
                    native
                    fullWidth
                    value={state.weight}
                    onChange={(event) => {
                      const value = event.target.value;
                      return setState((prevState) => {
                        return { ...prevState, weight: value };
                      });
                    }}
                    style={{ borderRadius: 50 }}
                  >
                    <option value="" />
                    {range(50, 500).map((value) => (
                      <option key={value} value={`${value} lb`}>
                        {value} lb
                      </option>
                    ))}
                  </Select>
                </Box>
              </Grid>
              <Grid sm={11} md={6} lg={6} xs={11}>
                <Box sx={{ width: '95%' }}>
                  <Typography variant="body2" color="text.secondary">
                    Height
                  </Typography>
                  <Select
                    native
                    fullWidth
                    value={state.height}
                    onChange={(event) => {
                      const value = event.target.value;
                      return setState((prevState) => {
                        return { ...prevState, height: value };
                      });
                    }}
                    style={{ borderRadius: 50 }}
                  >
                    <option value="" />
                    {map([3, 4, 5, 6], (feet) => {
                      return range(0, 12).map((value) => (
                        <option key={value} value={`${feet}' ${value}"`}>{`${feet}' ${value}"`}</option>
                      ));
                    })}
                  </Select>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <IconButton
            style={{
              position: 'absolute',
              top: 6,
              right: 6,
            }}
            onClick={onClose}
          />
          <Typography variant="subtitle1" style={{ color: 'red' }} textAlign="center">
            {state.errorMessage}
          </Typography>
          <Divider sx={{ mt: 4 }} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              pt: 4,
            }}
          >
            <Button
              text="Back"
              onClick={() =>
                setState((prev) => {
                  return { ...prev, step: 1 };
                })
              }
              bg="light"
            />
            <Button text="Pair" onClick={() => handlePairDevice(state)} loading={loader} />
          </Box>
        </Box>
      )}
    </Modal>
  );
};

export default AddDeviceModal;
